/* ---------- 5. placeholder text fill ---------- */

import type { EventContext } from '../lib/event-context';
import { formatZoned } from '../lib/time';

const TOKEN_RE = /\[(event_full|event_start)\]/g;
const SKIP_TAGS = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT']);

export const fillText = ({ title, start, zone }: EventContext) => {
  const values: Record<string, string> = { event_full: title, event_start: formatZoned(start, zone) };

  // TreeWalker visits only text nodes that can contain a token — no recursion, no element visits.
  const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, (node) =>
    (node.nodeValue ?? '').includes('[') && !SKIP_TAGS.has(node.parentElement?.tagName ?? '')
      ? NodeFilter.FILTER_ACCEPT
      : NodeFilter.FILTER_REJECT,
  );
  for (let node = walker.nextNode(); node; node = walker.nextNode()) {
    const text = node.nodeValue ?? '';
    const next = text.replace(TOKEN_RE, (_, key: string) => values[key] ?? '');
    if (next !== text) node.nodeValue = next;
  }
};
